import LocalStorageService from '@infrastructure/local-storage-service';
import jwtDecode from 'jwt-decode';
import { ClaimTypes } from '../constants/claim-types';
export const getCurrentUserFromJwt = (token) => {
    const authToken = token || LocalStorageService.getAccessToken();
    if (authToken != null) {
        const decodedJWT = jwtDecode(authToken);
        const currentUser = {
            accessToken: authToken,
            id: decodedJWT[ClaimTypes.NameIdentifier],
            name: decodedJWT[ClaimTypes.Name],
            role: decodedJWT[ClaimTypes.Role],
            email: decodedJWT[ClaimTypes.Email],
            createdBy: decodedJWT[ClaimTypes.Identifier],
            userName: decodedJWT[ClaimTypes.UserName],
            identifier: decodedJWT[ClaimTypes.Identifier],
            locations: decodedJWT[ClaimTypes.Locations],
        };
        return currentUser;
    }
};
